import { render, staticRenderFns } from "./modalModificarTipoVenta.vue?vue&type=template&id=45bc191e&"
import script from "./modalModificarTipoVenta.vue?vue&type=script&lang=js&"
export * from "./modalModificarTipoVenta.vue?vue&type=script&lang=js&"
import style0 from "./modalModificarTipoVenta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45bc191e')) {
      api.createRecord('45bc191e', component.options)
    } else {
      api.reload('45bc191e', component.options)
    }
    module.hot.accept("./modalModificarTipoVenta.vue?vue&type=template&id=45bc191e&", function () {
      api.rerender('45bc191e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/modales/modalModificarTipoVenta.vue"
export default component.exports